import _orderBy from 'lodash.orderby';

export function orderBy(list: any, column: string, order: any) {
  return _orderBy(list, [column], [order]);
}
